import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { getResidentDiscountProps } from '../../redux/currentSearch/selectors';

export const ResidentDiscount = ({
    children,
    hasNonAdults,
    regions,
}) => {
    const { t } = useTranslation();

    const hasRegions = regions.length > 0;

    const regionsText = regions
        .map((region) => {
            return ` ${region.charAt(0).toUpperCase()}${region.slice(1).toLowerCase()}`;
        })
        .join(` ${t('flightsManager.residentDiscount.oneliner.field.separator')}`);

    return children({ hasNonAdults, hasRegions, regionsText });
};

ResidentDiscount.propTypes = {
    children: PropTypes.func.isRequired,
    hasNonAdults: PropTypes.bool.isRequired,
    regions: PropTypes.arrayOf(PropTypes.string).isRequired,
};

const ConnectedResidentDiscount = connect(getResidentDiscountProps)(ResidentDiscount);

export { ConnectedResidentDiscount };
